import { gql } from "apollo-boost";

export const CREATE_BRAND = gql`
  mutation CreateBrand($data: BrandInput!) {
    createBrand(data: $data) {
      id
      message
    }
  }
`;

export const UPDATE_BRAND = gql`
  mutation UpdateBrand($data: BrandInput!, $where: BrandWhereInputOne!) {
    updateBrand(data: $data, where: $where) {
      id
      message
    }
  }
`;

export const DELETE_BRAND = gql`
  mutation DeleteBrand($where: BrandWhereInputOne!) {
    deleteBrand(where: $where) {
      id
      message
    }
  }
`;
